<template>
    <div>
        <div id="header">
            <img class="header-bg" src="../../assets/health/health.jpg" alt="">
            <div class="header-info">
              <div class="info-l">
                <p>{{step_count}}</p>
                <p>运动（步数）</p>
              </div>
                <div class="info-r">
                    <img :src='headimg' alt="">
                    <p>{{name}}</p>
                </div>
            </div>
        </div>
        <div id="content">
            <div class="main" id="main"></div>
            <div class="count">
                <div>
                    <p class="val">{{step_count}}</p>
                    <p class="title">步数/步</p>
                </div>
                <div style="border-left: 2px solid #fff;border-right: 2px solid #fff;">
                    <p class="val">{{kilometre}}</p>
                    <p class="title">历程/公里</p>
                </div>
                <div>
                    <p class="val">{{calorie}}</p>
                    <p class="title">卡路里/卡</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {motion} from '../../api/health';

    let echarts = require('echarts/lib/echarts');
    // 引入柱状图组件
    require('echarts/lib/chart/bar');

    // 引入提示框和title组件
    require('echarts/lib/component/title');
    require('echarts/lib/component/dataZoom');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');

    export default {
        name: "heartRate",
        data() {
            return {
                calorie: 0,
                kilometre: 0,
                step_count: 0,

                name: '',
                create_time: '',
                headimg: ''
            };
        },
        mounted() {
            let _this = this;
            document.title = '运动-健康管理';

            motion({token: this.$route.query.token})
                .then(res => {
                    if (res.code === 1) {
                        var X = []
                            , Y = [];
                        res.content.list.forEach(function (item) {
                            X.push(item.time);
                            Y.push(item.step_count);
                        });
                        this.drawLine(X, Y);
                        _this.calorie = res.content.calorie;
                        _this.kilometre = res.content.kilometre;
                        _this.step_count = res.content.step_count;

                        _this.name = res.content.info.name;
                        _this.headimg = res.content.info.headimg;
                        _this.create_time = res.content.info.create_time;
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        },
        methods: {
            drawLine(data, value) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('main'))
                // 绘制图表
                myChart.setOption({
                    color: ['#67D098'],
                    title: {
                        show: false
                    },
                    grid: {
                        left: '1%',
                        right: '5%',
                        containLabel: true
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {name: '运动'},
                    toolbox: {
                        show: true,
                        feature: {
                            // mark : {show: true},//辅助线
                            dataView: {show: true, readOnly: false},//数据视图
                            magicType: {show: true, type: ['line', 'bar']},
                            restore: {show: true},//还原
                            saveAsImage: {show: true}//保存图片
                        }
                    },
                    calculable: false,
                    xAxis: [
                        {
                            type: 'category',
                            data: data
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            axisLabel: {
                                formatter: '{value}'
                            }
                        }
                    ],
                    series: [{
                        name:'运动',
                        type:'bar',
                        data: value,
                        barWidth: '15%',
                    }]
                });
            }
        }
    };

</script>
<style lang="scss" scoped>
    #header {
        width: 100%;
        height: 500px;
    }

    #header .header-bg {
        width: 100%;
    }

    #header .header-info .info-l {
        float: left;
        padding-left: 15px;
        padding-top: 5px;
        text-align: center;
    }

    #header .header-info .info-l p:nth-child(1) {
        font-weight: bold;
        color: #333;
        font-size: 36px;
    }

    #header .header-info .info-l p:nth-child(2) {
        color: #999;
        font-size: 13px;
    }

    #header .header-info .info-r {
        float: right;
        text-align: right;
        font-family: PingFang SC;
        position: absolute;
        right: 15px;
        top: 388px;
    }

    #header .header-info .info-r img {
        width: 67px;
        height: 67px;
        border-radius: 50%;
    }

    #header .header-info .info-r p:nth-child(2) {
        font-weight: bold;
        color: #333;
        font-size: 15px;
        width: 67px;
        padding-left: 32px;
        text-align: center;
    }

    #header .header-info .info-r p:nth-child(3) {
        color: #999;
        font-size: 13px;
    }

    #content {
        width: 95%;
        margin: 0 auto;
        margin-bottom: 20px;
    }

    #content .main {
        height: 300px;
    }

    #content .count {
        height: 100px;
        margin: 0 auto;
        background-color: #bfefdf77;
        border-radius: 8px;
    }

    #content .count div {
        float: left;
        width: 32.9%;
        height: 100px;
        text-align: center;
    }

    #content .count .val {
        padding-top: 20px;
        font-size: 26px;
        color: #666666;
    }

    #content .count .title {
        font-size: 15px;
        color: #cccccc;
    }
</style>